import React from "react";
import Table from "./Table";
const PrintTable = ({ Owl }) => React.useMemo(() => <Table spliter={Owl.spliter} items={Owl.items} Owl={Owl} />, []);

export default PrintTable;
